/** @namespace $route.current */
/** @namespace $route.current.params */
module.exports = ["$route", "$scope", function($route, $scope) {
    const _controller = this;

    _controller.isFrontpage = () => (!$route.current || ($route.current && !$route.current.params.id));

    _controller.isLoaded = () => true;

    (function init() {

    }());
}];
